/* eslint eqeqeq:'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import SelectAllCheckboxes from '../../../Resources/SelectAllCheckboxes';
import { createFilter } from 'react-search-input';
import ErrorGif from '../../../Assets/images/Error.gif';
import * as ErrorMessage from '../../../Resources/ErrorMessages';
import { Table, Button, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal } from "reactstrap";
import classnames from 'classnames';
import ReactPaginate from 'react-paginate';
import DeleteConfirmation from './_ModalsForms/WorkOrderDeleteConfirmation';
import { GetWorkOrderReportsList, GenerateWOReportPDF, GetWorkOrderReportsDetails, GenerateWOReportXLS, DeleteReports } from '../../../action/workorderAction';
import CreateReport from './Reports/CreateReports';
import CreateReportDetails from "components/EnsembleComponents/WorkOrderComponents/Reports/CreateReportDetails";
import LoadingIndicator from '../Common/LoadingIndicator';
import { setAmplitudeEvent } from 'amplitude/amplitude';

const KEYS_TO_FILTERS = ['reportName', 'description'];
let pagesCount = 0;

class WorkOrderReports extends Component {

    componentWillMount() {
        this.props.GetWorkOrderReportsList().then(() => {this.setState({isloading:false})});
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            closeCreate: false,
            closeActions: false,
            error_msg: false,
            sort: {
                column: null,
                direction: [
                    { name: 'reportName', direction: 'asc', onclick: true },
                    { name: 'description', direction: 'desc', onclick: false }
                ]
            },
            searchTerm: "",
            selectedReportId: 0,
            selectedReportName: '',
            selectedReportType: 0,
            hasMultipleSelected: false,
            currentPage: 0,
            pageSize: 50,
            IsDefaultSort: true,
            IsRedirect: false,
            redirect_ReportDetails: false,
            reportID: '',
            isEdit: false,
            deletemodal: false,
        };
        this.toggleActions = this.toggleActions.bind(this);
        this.toggleCreate = this.toggleCreate.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.setSelectedReports = this.setSelectedReports.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.onSort = this.onSort.bind(this);
        this.Redirect_To_ReportList = this.Redirect_To_ReportList.bind(this);
    }

    Redirect_To_ReportList(){
        this.setState({ IsRedirect : false, redirect_ReportDetails: false, selectedReportId: 0, hasMultipleSelected:false});
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
         if(scrollPageTop[0] !== undefined){
             (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
         }
    }

    toggleActions() { this.setState({ closeActions: !this.state.closeActions }); }
    toggleCreate() { this.setState({ closeCreate: !this.state.closeCreate }); }

    /* Filter System */
    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.WOReport_search_value.value, currentPage: 0 })
    }

    handlePageClick = data => {
        let selected = data.selected;
        this.setState({ currentPage: selected });
         var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
         if(scrollPageTop[0] !== undefined){
             (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
         }
    };

    onSort = (column) => (e) => {
        this.setState({ IsDefaultSort: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state =  this.props.getWorkOrderReportsList.WorkorderReportsList;
        var notequals = 0;
        if (data_from_state != null) {
            const sortedData =  data_from_state.sort((a, b) => {
                let nameA, nameB;
                if (column === "reportName" || column === "description") {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                    if (nameA < nameB) {
                        notequals = 1;
                        return -1;
                    }
                    if (nameA > nameB) {
                        notequals = 1;
                        return 1;
                    }
                    if (nameA === nameB) {
                        return 0;
                    }
                    return 0;
                }
                else{
                    return 0;
                }

            });
            if (selected[0].direction === 'asc' && notequals === 1) {
                sortedData.reverse();
            }
            if (selected[0].name === "reportName") {
                SortData[0].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "reportName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name === "description") {
                SortData[1].direction = direction;
                // eslint-disable-next-line
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "description") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
           

            this.props.getWorkOrderReportsList.WorkorderReportsList = sortedData;
            this.setState({
                sort: {
                    column,
                    direction: SortData,
                }
            });
          
        
        }
    };

    setSelectedReports() {
        var ckboxes = document.getElementsByClassName('WorkOrderReportRows');
        var ct = 0;
        var selId = 0;
        var rName = '';
       // var tpe = 0;
     
        for (var itm of ckboxes) {
          if (itm.checked) {
            if (ct === 0) {
                selId = itm.id;
              //if (spl.length >= 2){
                //selId = spl[0]; 
                //tpe = parseInt(spl[1]);
                rName = itm.name;
              //} 
            }
            ct++;
          }
        }
    
        this.setState({ selectedReportId: ct > 1 ? 0 : selId});
        this.setState({ hasMultipleSelected : ct > 1 });
       // this.setState({ selectedReportType: ct === 1 && tpe > 0 ? tpe : 0});
        this.setState({ selectedReportName: ct === 1 && rName !== '' ? rName : ''});
        SelectAllCheckboxes.ResetHeaderCheckBox("WorkOrderReportRows", "WOTenant_header_Check_box");
      }

    CreateNewReport = () => {
        this.setState({IsRedirect: true, isEdit: false});
    }
   
    createArtifact(format){
        var Data = [];
        var checkboxes = document.getElementsByClassName('WorkOrderReportRows');
        var ReportTypeName;
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                let reportID = {
                    "ReportID" : checkboxes[i].id,
                    "ReportType" : checkboxes[i].getAttribute('reporttype')
                }
                ReportTypeName = checkboxes[i].getAttribute('reporttype');
                let reportName = checkboxes[i].name;
                Data.push({reportID,reportName});
            }
        }
        if(Data.length){
            if(format === "pdf"){
                Data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.GenerateWOReportPDF(arrayItem.reportID,arrayItem.reportName),setAmplitudeEvent("WO/PM Generate PDF Report",{"Report Type": ReportTypeName , "Page Type" : "List Page"})  ), Promise.resolve());                
            }
            if(format === "Excel"){
                Data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.GenerateWOReportXLS(arrayItem.reportID,arrayItem.reportName), setAmplitudeEvent("WO/PM Generate Excel Report",{"Report Type": ReportTypeName , "Page Type" : "List Page"})), Promise.resolve());                
            }
        }
    } 

    DeleteReports(){
        this.setState({deletemodal: !this.state.deletemodal});
    }

    Delete = (someArg) => {
        if (someArg == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('WorkOrderReportRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    var report_id_to_be_deleted = {
                        "reportId": checkboxes[i].id
                    }
                    Data.push(report_id_to_be_deleted);
                }
            }
            this.props.DeleteReports(Data);
        }
        this.DeleteReports();
    }

    EditReportDetails(id){
        const response = this.props.GetWorkOrderReportsDetails(id);
        response.then(() => {
            this.setState({redirect_ReportDetails:true, reportID: id, isEdit:true})
        })
    }

    render(getLabels,getWorkOrderReportsList) {
        let Reports, WO_Report_Data, Error_Message = null;
        let lTenantlength = 0, lCurrentTenantlength = 0;
        let label = this.props.getLabels;

        let { closeActions } = this.state;

        // Tenant_Data = this.props.getResponse.TenantsList;
        WO_Report_Data = this.props.getWorkOrderReportsList.WorkorderReportsList;
        if (WO_Report_Data != undefined && WO_Report_Data != null && WO_Report_Data.length > 0 && !this.state.isloading) {

            if (this.state.IsDefaultSort) {
                //eslint-disable-next-line
                let sortedData = WO_Report_Data.sort((a, b) => {
                    let nameA = a['reportName'].toLowerCase();
                    let nameB = b['reportName'].toLowerCase();

                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    if (nameA == nameB) {
                        return 0;
                    }
                    return 0;
                });
            }
            

            let FilteredData = WO_Report_Data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            lTenantlength = FilteredData.length;
            pagesCount = Math.ceil(FilteredData.length / this.state.pageSize);
            Reports = FilteredData.length ? FilteredData.slice(this.state.currentPage * this.state.pageSize, (this.state.currentPage + 1) * this.state.pageSize
            ).map(el => {


                return <tr key={el.reportID}>
                    <td width="5%"><input type="checkbox" id={el.reportID} name={el.reportName} reporttype={el.reportType} className="WorkOrderReportRows" onClick={() => { this.setSelectedReports() }} /></td>
                    <td width="25%"><p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => this.EditReportDetails(el.reportID)}>{el.reportName}</p></td>
                    <td width="50%">{el.description}</td>

                </tr>
            }) : <tr><td colSpan="5"> No Records Found</td></tr>;
            if (Reports.length !== undefined)
                lCurrentTenantlength = Reports.length;
        } else if(!this.state.isloading) {
            Reports = <tr><td colSpan="5">No Records Found</td></tr>
        } else{
            Reports = <tr><td colSpan="5" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
        }

        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.selection_error_alt}</p> : Error_Message = "";

        return (
           this.state.redirect_ReportDetails ? <CreateReportDetails isEdit={this.state.isEdit} reportID={this.state.reportID} Redirect_To_ReportList={this.Redirect_To_ReportList}/> :
            this.state.IsRedirect ? <CreateReport selectedReportType="1" Redirect_To_ReportList={this.Redirect_To_ReportList} /> :
            <div className="main_container">
                <div className="border_container">
                    <div className="main_container">
                        <div className="row row_padding" style={{ 'marginLeft': '0px', 'marginRight': '0px' }}>
                            <div className="col-md-12">
                                {Error_Message}
                            </div>
                        </div>



                        <div className="row row_padding" style={{ 'marginLeft': '0px', 'marginRight': '0px' }}>
                            <div className="col-md-12">

                                <UncontrolledButtonDropdown isOpen={closeActions} toggle={this.toggleActions}>
                                    <DropdownMenu >
                                        <DropdownItem className="reports_menu_dropdown_item singleOnly" id="action_option_generate_pdf" disabled={!this.state.hasMultipleSelected && this.state.selectedReportId === 0} onClick={() => this.createArtifact("pdf")}>Generate PDF</DropdownItem>
                                        <DropdownItem divider />
                                        <DropdownItem className="reports_menu_dropdown_item singleOnly" id="action_option_generate_xls" disabled={!this.state.hasMultipleSelected && this.state.selectedReportId === 0} onClick={() => this.createArtifact("Excel")}>Generate XLS</DropdownItem>
                                        <DropdownItem divider />
                                        <DropdownItem className="reports_menu_dropdown_item singleOnly" id="action_option_delete" disabled={!this.state.hasMultipleSelected && this.state.selectedReportId === 0} onClick={() => this.DeleteReports()}>Delete</DropdownItem>

                                    </DropdownMenu>
                                    <DropdownToggle caret className="CR_btn_Dropdown_action_caret" style={{'textAlign': 'center'}} id="report_action_dropdown"  onClick={() => this.toggleActions}>ACTIONS &nbsp;&nbsp;&nbsp;&nbsp;</DropdownToggle>
                                </UncontrolledButtonDropdown>

                                <label id="report_num_of_records_within_this_page" className="child_tab_paginationtext">{(lTenantlength !== 0 ? this.state.currentPage * 50 + 1 : 0) + "-" + ((this.state.currentPage * 50) + lCurrentTenantlength) + " of " + lTenantlength + " records"}</label>
                                <Button id="report_create_new_report_button" className="child_tab_button_template" style={{ 'width': '163px', 'marginLeft': '8px' }} onClick={() => { this.CreateNewReport() }} >Create New Report</Button>

                                <span className="pm_outersearchbox" style={{ float: 'right' }}>
                                    <input id="report_search_textbox" type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'marginTop': '3px' }} placeholder="Enter Value..." value={this.state.searchTerm} onChange={this.searchUpdated} ref='WOReport_search_value' />
                                </span>
                                <label id="report_search_label" style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', 'marginTop': '4px' }}>{label !== undefined ? label['PreventativeMaintenance.Search.Text'] : "Search:"}</label>
                            </div>
                        </div>
                        <br />
                        <div className="table_container table_border" style={{ 'marginBottom': '0px', 'marginRight': '15px', 'marginLeft': '15px' }}>
                            <Table id="report_list_table" striped responsive className="Custom_table">
                                <thead className="cell_container_header">
                                    <tr>
                                        <th width="5%"><input type="checkbox" className="WOTenant_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("WorkOrderReportRows", "WOTenant_header_Check_box"); this.setSelectedReports()}} /></th>
                                        <th  width="25%" onClick={this.onSort('reportName')} className="wo_cursor">
                                            <span>{label['WorkOrder.ReportName.Text'] !== undefined ? label['WorkOrder.ReportName.Text'] : "Report Name"}</span>
                                            <span className={(this.state.sort.direction[0].name == "reportName") ?
                                                (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                            </span>
                                        </th>
                                        <th  width="50%" onClick={this.onSort('description')} className="wo_cursor">
                                            <span>{label['WorkOrder.ReportDescription.Text'] !== undefined ? label['WorkOrder.ReportDescription.Text'] : "Description"}</span>
                                            <span className={(this.state.sort.direction[1] !== undefined && this.state.sort.direction[1].name == "description") ?
                                                (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="cell_container kpi_table_tbody cell_container_body" style={{maxHeight:this.props.OnPremises ? "270px": "315px"}}>
                                    {Reports}
                                </tbody>
                            </Table>
                        </div>
                        <div className="row row_padding pm_pagination" style={{ 'marginRight': '15px' }}>
                            <div className="col-md-7">
                                <ReactPaginate
                                    previousLabel={'Prev'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me pagination_margin'}
                                    breakLinkClassName={'pagination_link_color'}
                                    pageCount={pagesCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={10}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={'pagination pagination_container_margin'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    disabledClassName={'pagination_disable_link'}
                                    pageClassName={'pagination_margin'}
                                    pageLinkClassName={'pagination_link_color'}
                                    previousClassName={'pagination_margin'}
                                    previousLinkClassName={'pagination_link_color'}
                                    nextClassName={'pagination_margin'}
                                    nextLinkClassName={'pagination_link_color'}
                                    forcePage={this.state.currentPage}
                                />
                            </div>
                        </div>
                        <Modal isOpen={this.state.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                            <DeleteConfirmation parentToChildData={!this.state.hasMultipleSelected ? ["Delete Report", "You are about to delete a report from the system. Do you want to continue?"] : ["Delete Report", "You are about to delete report(s) from the system. Do you want to continue?"]} Delete={this.Delete} />
                        </Modal>
                 </div> 
                </div> 
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkOrderReportsList: state.WorkorderRootReducer,
        OnPremises: state.authService.IsOnPremise,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetWorkOrderReportsList: () => dispatch(GetWorkOrderReportsList()),
        GenerateWOReportPDF: (reportID,reportName) => dispatch(GenerateWOReportPDF(reportID,reportName)),
        GetWorkOrderReportsDetails: (reportID) => dispatch(GetWorkOrderReportsDetails(reportID)),
        GenerateWOReportXLS: (reportID,reportName) => dispatch(GenerateWOReportXLS(reportID,reportName)),
        DeleteReports: (reportId) => dispatch(DeleteReports(reportId))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderReports);
